import { Alerts } from '@/framework/base/helpers/Alerts';
import { Fiches } from '@/generated/classes/AppSchema';

export class Schema {
  public modules: Module[];
}

export class Module {
  public name: string;
  public label: string;
  public fiches: Fiche[];
}

export class Fiche {
  public name: string;
  public label: string;
  public sections: Section[];
}

export class Section {
  public name: string;
  public label: string;
  public objType: string;
  public attributs: Attribut[];
}

export class Extended {
  public name: string;
  public fiche: Fiches;
  public value: boolean;
  constructor(name: string, fiche: Fiches, value: boolean) {
    this.name = name;
    this.fiche = fiche;
    this.value = value;
  }
}

export class Attribut {
  public name: string;
  public required: boolean;
  public readOnly: boolean;
  constructor(n: string, r: boolean, ro: boolean) {
    this.name = n;
    this.required = r;
    this.readOnly = ro;
  }
}

export function getLabel (schema: Schema, module: string, fiche = '', section = ''): string {
  const existMod = schema.modules.find(a => a.name.toLowerCase() == module.toLowerCase());
  if (existMod) {
    const mod: Module = existMod;
    if (fiche == '') {
      return mod.label;
    } else {
      const existFic = mod.fiches.find(a => a.name.toLowerCase() == fiche.toLowerCase());
      if (existFic) {
        const fic: Fiche = existFic;
        if (section == '') {
          return fic.label;
        } else {
          const existSec = fic.sections.find(a => a.name.toLowerCase() == section.toLowerCase());
          if (existSec) {
            const sec: Section = existSec;
            return sec.label;
          } else {
            Alerts.debug('La section ' + section + ' n\'existe pas dans la fiche ' + fiche + ' du module ' + module);
          }
        }
      } else {
        Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
      }
    }
  } else {
    Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
  }
  return 'getLabel : ERROR'
}

export function getAttributs (schema: Schema, module: string, fiche: string, section: string): Attribut[] {
    const existMod = schema.modules.find(a => a.name == module);
    if (existMod) {
      const mod: Module = existMod;
      const existFic = mod.fiches.find(a => a.name == fiche);
      if (existFic) {
        const fic: Fiche = existFic;
        const existSec = fic.sections.find(a => a.name == section);
        if (existSec) {
          const sec: Section = existSec;
          return sec.attributs;
        } else {
          Alerts.debug('La section ' + section + ' n\'existe pas dans la fiche ' + fiche + ' du module ' + module);
        }
      } else {
        Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
      }
    } else {
      Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
    }
    return [];
}

export function getObjType (schema: Schema, module: string, fiche: string, section: string): string {
  const existMod = schema.modules.find(a => a.name == module);
  if (existMod) {
    const mod: Module = existMod;
    const existFic = mod.fiches.find(a => a.name == fiche);
    if (existFic) {
      const fic: Fiche = existFic;
      const existSec = fic.sections.find(a => a.name == section);
      if (existSec) {
        const sec: Section = existSec;
        return sec.objType;
      } else {
        Alerts.debug('La section ' + section + ' n\'existe pas dans la fiche ' + fiche + ' du module ' + module);
      }
    } else {
      Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
    }
  } else {
    Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
  }
  return '';
}


export function getSections (schema: Schema, module: string, fiche: string): string[] {
  const res: string[] = [];
  const existMod = schema.modules.find(a => a.name == module);
  if (existMod) {
    const mod: Module = existMod;
    const existFic = mod.fiches.find(a => a.name == fiche);
    if (existFic) {
      existFic.sections.forEach(s => res.push(s.name));
      return res;
    } else {
      Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
    }
  } else {
    Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
  }
  res.push('ERROR')
  return res;
}

export function isSection (schema: Schema, module: string, fiche: string, section: string): boolean {
  const existMod = schema.modules.find(a => a.name == module);
  if (existMod) {
    const mod: Module = existMod;
    const existFic = mod.fiches.find(a => a.name == fiche);
    if (existFic) {
      const existSection = existFic.sections.find(a => a.name == section);
      if (existSection) {
        return true;
      } else {
        Alerts.debug('La section ou dialogue ' + section + ' n\'existe pas dans la fiche module ' + fiche + ' du module ' + module);
      }
    } else {
      Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
    }
  } else {
    Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
  }
  return false;
}

export function sectionIndex (schema: Schema, module: string, fiche: string, section: string): number {
  const indexModule = schema.modules.findIndex(a => a.name == module);
  if (indexModule >= 0) {
    const mod: Module = schema.modules[indexModule];
    const indexFiche = mod.fiches.findIndex(a => a.name == fiche);
    if (indexFiche >= 0) {
      const fic = mod.fiches[indexFiche];
      const indexSection = fic.sections.findIndex(a => a.name == section);
      if (indexSection >= 0) {
        return 10000 * indexModule + 100 * indexFiche + indexSection;
      } else {
        Alerts.debug('La section ou dialogue ' + section + ' n\'existe pas dans la fiche module ' + fiche + ' du module ' + module);
      }
    } else {
      Alerts.debug('La fiche ' + fiche + ' n\'existe pas dans le module ' + module);
    }
  } else {
    Alerts.debug('Le module ' + module + ' n\'existe pas dans le schéma');
  }
  return -1;
}